const LocationService = {
  getLocation: () => {
    return new Promise((resolve, reject) => {
      fetch(
        'https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyB_Gob1-ls7DqnjHbJHhpDJ81WN2xFK0ig',
        {
          method: 'POST',
        },
      )
        .then((response) => response.json())
        .then((data) => {
          const location = data?.location
          resolve(location)
        })
        .catch((error) => reject(error))
    })
  },

  getCountry: (location) => {
    return new Promise((resolve, reject) => {
      const geocoder = new window.google.maps.Geocoder()
      geocoder.geocode({ location }, (results, status) => {
        if (status === window.google.maps.GeocoderStatus.OK) {
          const addrComponents = results[0]?.address_components || []
          for (let i = 0; i < addrComponents.length; i++) {
            if (addrComponents[i].types[0] === 'country') {
              const countryCode = addrComponents[i].short_name
              resolve(countryCode)
            }
          }
        } else {
          reject(`Geocode was not successful for the following reason: ${status}`)
        }
      })
    })
  },
  initializeMaps: () => {
    console.log('initializing maps')
    var script = document.createElement('script')
    script.src =
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyB_Gob1-ls7DqnjHbJHhpDJ81WN2xFK0ig&callback=initialize'
    document.head.appendChild(script)
    console.log('Google Maps Script Added')
  },
}

export default LocationService
